export default class BusinessTaxReturnFilter {
    public companyId: number | null = null;

    public period: string | null = null;
}